import ToolIcon from "@redotech/redo-icons/tool-02.svg";
import { Step as ModelStep, Payer } from "@redotech/redo-model/return-flow";
import { submitRepairFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isSubmitRepairStepValid,
  SubmitRepairState,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SUBMIT_REPAIR = (
  Details: React.ComponentType<StepTypeDetailsProps<SubmitRepairState>>,
): StepType<SubmitRepairState, ModelStep.SubmitRepair> => ({
  Details: (props: StepTypeDetailsProps<SubmitRepairState>) =>
    React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  title: "Submit Repair",
  valid(state) {
    return isSubmitRepairStepValid(state).valid;
  },
  Icon: ToolIcon,
  description() {
    return "Submit a repair request";
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: { option: { labelPayer: Payer.CUSTOMER, chargeFee: true } },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SUBMIT_REPAIR,
      option: {
        labelPayer: state.option.labelPayer,
        chargeFee: state.option.chargeFee,
      },
    };
  },
  fromModel(model) {
    return submitRepairFromModel(model);
  },
});

export {
  type SubmitRepairOption,
  type SubmitRepairState,
} from "@redotech/redo-model/return-flow-step-valid";
